import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Build-stamp lives in App.tsx now (single source of truth). Earlier
// commits assigned `globalThis.SCRATCH_WEB_BUILD` here too — but
// since main.tsx's module body runs AFTER App.tsx's (as a consumer
// import), this assignment always won and clobbered App.tsx's
// bumped value. Symptom: every "new build" reported the same stale
// stamp `2026-06-08-rev2` via `globalThis.SCRATCH_WEB_BUILD` even
// after rebuilding and re-deploying, which gaslit several reveal-
// animation debugging sessions on 2026-06-09 before the duplicate
// was found. Don't re-introduce it here.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
